module.exports = __webpack_public_path__ + "img/dwarf_14.23019528.png";